<template>
    <div v-if="showToolbar" style="z-index: 10000; position: absolute; width: 100%" >

    <v-toolbar absolute height="70" v-if="$vuetify.breakpoint.lgAndUp" color="#f5f5f5" style="width: 100%;">
        <v-btn class="mr-2" icon @click="setMenuOpen(true)"><v-icon>menu</v-icon></v-btn>
            <v-flex xs3 style="margin-top: 30px;">
                <v-autocomplete
                        ref="autocomplete"
                        class="mb-1"
                        v-model="selectedBuilding"
                        v-on:click="selectedBuilding = {}"
                        :loading="buildings.length==0 ? true : false"
                        @change="closeKeyboard"
                        auto-select-first
                        autocomplete
                        single-line
                        flat solo
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        :items="buildingItems"
                        return-object
                        :filter="customFilter"
                        :label="buildings.length==0 ? 'Loading...' : 'Building Name / Number / Addr'">

                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-card flat class="py-5 px-5">
                                        <span class="body-2">{{buildings.length==0 ? 'Loading...' : 'Not Found'}}</span>
                                    </v-card>
                                </v-list-item-title>
                            </v-list-item>
                        </template>

                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-list-item v-bind="attr" v-on="on">
                                <v-list-item-avatar dark tile color="grey darken-3" style="color: white;">
                                    {{item.bldgAlpha}}
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title >
                                    {{item.name}}
                                  </v-list-item-title>
                                  <v-list-item-subtitle v-text="item.address"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template v-slot:item="{ item, attrs, on }" >
                            <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-avatar dark tile color="grey darken-3" style="color: white;">
                                    {{item.bldgAlpha}}
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{item.name}}
                                  </v-list-item-title>
                                  <v-list-item-subtitle v-text="item.address"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
            </v-flex>

            <v-flex xs1 class="pl-3" style="margin-top: 30px;"> 
                <v-autocomplete
                        class="roomAutocomplete mb-1"
                        ref="roomSelect"
                        v-model="selectedRoom"
                        :loading="selectedBuilding && buildingRooms.length==0 ? true : false"
                        item-text="number"
                        item-value="number"
                        flat solo
                        auto-select-first                        
                        clearable
                        :items="buildingRooms"
                        :label="selectedBuilding && buildingRooms.length==0 ? 'Loading...' : 'Room'"                   
                        return-object
                    >
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-card flat class="py-5 px-5">
                                        <span class="body-2">{{selectedBuilding && buildingRooms.length==0 ? 'Loading...' : 'Not Found'}}</span>
                                    </v-card>
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-list-item v-bind="attr" v-on="on" class="body-1">
                                <v-layout align-end justify-center>
                                    <v-flex xs12 grow class="text-xs-center">
                                    {{item.number.replace(/^0+/, '')}}                                    
                                    </v-flex>
                                </v-layout>
                            </v-list-item>
                        </template>

                        <template v-slot:item="{ item, attrs, on }" >
                            <v-list-item v-bind="attrs" v-on="on" class="body-1">
                                {{item.number.replace(/^0+/, '')}}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
            </v-flex>
            <v-flex xs1 class="ml-3">
<!--                 <v-autocomplete 
                    :items="elevatorItems"
                    flat
                    solo
                    label="Floor"
                    v-model="currentFloor"
                    >
                </v-autocomplete> -->
            </v-flex>
            <v-flex class = "">
                <v-toolbar-title class="topTitle">  
                        <v-layout align-center row fill-height>         
                        <img src="https://interactivefloorplans.arizona.edu/static/img/ua_block_rgb_3.3c82a4c.3c82a4c.png" class="blocka">
                        <a href="/" 
                            style="text-decoration: none; color: black;" >
                                Room Finder
                        </a>
                        </v-layout>
                </v-toolbar-title>  
            </v-flex>
    </v-toolbar>

    <!-- SMALLER LAYOUT -->

    <v-expansion-panels v-model="expansion" v-if="$vuetify.breakpoint.mdAndDown">
    <v-expansion-panel class="" >
    
    <v-expansion-panel-header>
        <v-layout  justify-end align-center>           
            <v-flex >
                <img src="https://interactivefloorplans.arizona.edu/static/img/ua_block_rgb_3.3c82a4c.3c82a4c.png" class="phoneBlocka">
            </v-flex>
            <v-flex class="topTitlePhone" style="">
                <div>Room Finder</div>
            </v-flex>
            <v-flex 
             style="" class="text-xs-right">
             <v-icon right medium style="float:right;">
                {{expansion == undefined ? 'search' : 'expand_less'}}
             </v-icon></v-flex>
        </v-layout>
    </v-expansion-panel-header>
    
    <v-expansion-panel-content expand-icon="">

        <v-card flat height="200">
            <v-divider></v-divider>
            <v-layout class="pt-5" column >
                <v-flex>
                    <v-autocomplete
                        class="bldgAutocomplete"
                        ref="autocomplete"
                        v-model="selectedBuilding"
                        v-on:click="selectedBuilding = {}"
                        :loading="buildings.length==0 ? true : false"
                        @change="closeKeyboard"
                        auto-select-first
                        autocomplete
                        single-line
                        
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        :items="buildingItems"
                        return-object
                        :filter="customFilter"
                        :label="buildings.length==0 ? 'Loading...' : 'Building Name / Number / Addr'">

                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-card flat class="py-5 px-5">
                                        <span class="body-2">{{buildings.length==0 ? 'Loading...' : 'Not Found'}}</span>
                                    </v-card>
                                </v-list-item-title>
                            </v-list-item>
                        </template>

                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-list-item v-bind="attr" v-on="on">
                                <v-list-item-avatar dark tile color="grey darken-3" style="color: white;">
                                    {{item.bldgAlpha}}
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title >
                                    {{item.name}}
                                  </v-list-item-title>
                                  <v-list-item-subtitle v-text="item.address"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template v-slot:item="{ item, attrs, on }" >
                            <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-avatar dark tile color="grey darken-3" style="color: white;">
                                    {{item.bldgAlpha}}
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{item.name}}
                                  </v-list-item-title>
                                  <v-list-item-subtitle v-text="item.address"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex >
                    <v-autocomplete
                        class="roomAutocomplete"
                        ref="roomSelect"
                        v-model="selectedRoom"
                        :loading="selectedBuilding && buildingRooms.length==0 ? true : false"
                        item-text="number"
                        item-value="number"
                        auto-select-first                        
                        clearable
                        :items="buildingRooms"
                        :label="selectedBuilding && buildingRooms.length==0 ? 'Loading...' : 'Room'"                   
                        return-object
                    >
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-card flat class="py-5 px-5">
                                        <span class="body-2">{{selectedBuilding && buildingRooms.length==0 ? 'Loading...' : 'Not Found'}}</span>
                                    </v-card>
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-list-item v-bind="attr" v-on="on" class="body-1">
                                <v-layout align-end justify-center>
                                    <v-flex xs12 grow class="text-xs-center">
                                    {{item.number.replace(/^0+/, '')}}                                    
                                    </v-flex>
                                </v-layout>
                            </v-list-item>
                        </template>

                        <template v-slot:item="{ item, attrs, on }" >
                            <v-list-item v-bind="attrs" v-on="on" class="body-1">
                                {{item.number.replace(/^0+/, '')}}
                            </v-list-item>
                        </template>
                    </v-autocomplete>

                </v-flex>
            </v-layout>
        </v-card>
    </v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>
</div>

</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
name: "App",

data () {
    return {
        expansion: null,
    }
},

/*mounted: function () {
    this.fetchBuildings()
},*/

computed: {
    ...mapState({   buildings :     state => state.space.buildings,
                    buildingRooms:  state => state.space.buildingRooms,
                    showToolbar:    state => state.ui.showToolbar,       
                }),

    buildingItems: function() {
        const items = [];
        this.$store.state.space.buildings.forEach(bldg => {
            bldg.text = `${bldg.bldgAlpha} - ${bldg.name}`
            bldg.value = bldg.bldgAlpha
            items.push(bldg)
        });
        return items
    },

/*    roomItems : function () {
      return this.$store.state.space.buildingRooms.map((room) => {return room.number})
    },*/

    selectedBuilding : {
        get () {
            return this.$store.state.space.selectedBuilding
        },

        set (value) {   
            if (value && value.bldgAlpha) { 
                this.setSelectedBuilding(value)  
                this.fetchBuildingRooms(value.bldgAlpha)
                this.highlightBuilding({ 'bldgAlpha': value.bldgAlpha })

                if (this.$route.path.includes('dev')) {
                    this.$router.push({ 
                        name: "devBldg", 
                        params: {   bldg: this.$store.state.space.selectedBuilding.bldgAlpha } 
                    })
                } else {
                    this.$router.push({ 
                        name: "highlightBuilding", 
                        params: {   bldg: this.$store.state.space.selectedBuilding.bldgAlpha } 
                    })  
                } 
                this.setSelectedRoom(null)
            }       
        }
    },

    selectedRoom : {
        get () {
            return this.$store.state.space.selectedRoom ? this.$store.state.space.selectedRoom.number : null
        },
        set (value) {
            //this.findRoom(value)
            this.setSelectedRoom(value)
            this.highlightRoom(value)

/*            if (this.$route.path.includes('dev')) {
                this.$router.push({ 
                    name: "devRoom", 
                    params: {   bldg: this.$store.state.space.selectedBuilding.bldgAlpha, 
                                room: value.number } 
                })  
            } else {*/
                this.$router.push({ 
                    name: "highlightRoom", 
                    params: {   bldg: this.$store.state.space.selectedBuilding.bldgAlpha, 
                                room: value.number } 
                }) 
/*            }*/     
    

            //this.expansion = null
            this.setShowToolbar(false)
        }
    },
},

methods: { 

    ...mapMutations([       'setSelectedRoom', 'setShowToolbar',  
                            'setSelectedBuilding', 'setMenuOpen',
                    ]),

    ...mapActions([         'fetchBuildings', 
                            'fetchBuildingRooms',
                            'highlightRoom', 'highlightBuilding',
                            'findRoom',             
                    ]),

    customFilter(item, queryText, itemText) {
        const bldgAlpha = item.bldgAlpha.toLowerCase();
        const searchBlob =
            item.bldgAlpha +
            item.name +
            item.address +
            item.city +
            item.state +
            item.abbrev +
            item.commonName +
            item.shortName +
            item.aliasName;

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3) {
            return (
                searchBlob
                    .toLowerCase()
                    .indexOf(queryText.toLowerCase()) > -1
            );
        } else {
            return bldgAlpha.indexOf(queryText.toLowerCase()) > -1;
        }
    },

    closeKeyboard () {
      this.$refs.autocomplete.blur()
      this.$refs.roomSelect.blur()
    },

    menuOpen () {

    },
},



}
</script>
<style>
.phoneBlocka {
    height: 45px;
}

.toolbar {
/*    border-bottom: solid;
    border-color: grey;
    border-width: 2px;*/
    position: absolute;
    width: 100vw;
}

.blocka {
  height: 45px;
  margin-right: 20px;
  margin-left: 20px;
  float: left;
}

.bldgAutocomplete .v-input__slot {
    padding: 0px !important;
}

.bldgAutocomplete .v-list-item {
    padding: 0px !important;
}

.v-list-item {
    justify-content: center;
}

.topTitlePhone {
    font-family: 'Open Sans', sans-serif;
    font-size: 20px;
    position:relative; top: 0px;
    text-align: center;
}
</style>